var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "copy-01",
    clipPath: "url(#clip0_1301_8022)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M4.1665 12.4998C3.38993 12.4998 3.00165 12.4998 2.69536 12.373C2.28698 12.2038 1.96253 11.8794 1.79337 11.471C1.6665 11.1647 1.6665 10.7764 1.6665 9.99984V4.33317C1.6665 3.39975 1.6665 2.93304 1.84816 2.57652C2.00795 2.26292 2.26292 2.00795 2.57652 1.84816C2.93304 1.6665 3.39975 1.6665 4.33317 1.6665H9.99984C10.7764 1.6665 11.1647 1.6665 11.471 1.79337C11.8794 1.96253 12.2038 2.28698 12.373 2.69536C12.4998 3.00165 12.4998 3.38993 12.4998 4.1665M10.1665 18.3332H15.6665C16.5999 18.3332 17.0666 18.3332 17.4232 18.1515C17.7368 17.9917 17.9917 17.7368 18.1515 17.4232C18.3332 17.0666 18.3332 16.5999 18.3332 15.6665V10.1665C18.3332 9.23308 18.3332 8.76637 18.1515 8.40985C17.9917 8.09625 17.7368 7.84128 17.4232 7.68149C17.0666 7.49984 16.5999 7.49984 15.6665 7.49984H10.1665C9.23308 7.49984 8.76637 7.49984 8.40985 7.68149C8.09625 7.84128 7.84128 8.09625 7.68149 8.40985C7.49984 8.76637 7.49984 9.23308 7.49984 10.1665V15.6665C7.49984 16.5999 7.49984 17.0666 7.68149 17.4232C7.84128 17.7368 8.09625 17.9917 8.40985 18.1515C8.76637 18.3332 9.23308 18.3332 10.1665 18.3332Z",
    stroke: "#344054",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1301_8022"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.48886481704b0f26106084ca6143a2b9.svg";
export { ForwardRef as ReactComponent };